import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-10 flex flex-col items-center relative pb-20 px-10" }
const _hoisted_2 = { class: "w-full max-w-7xl xl:px-10" }
const _hoisted_3 = { class: "grid xl:grid-cols-2 gap-20 xl:gap-0 mb-20 items-center" }
const _hoisted_4 = { class: "text-primary-focus text-5xl lg:text-7xl font-captions font-bold" }
const _hoisted_5 = { class: "leading-loose text-[#7C7C7C] max-w-3xl whitespace-pre-line" }
const _hoisted_6 = { class: "flex justify-between flex-col xl:flex-row flex-col-reverse flex-wrap w-full w-full max-w-7xl mb-20 xl:pt-20 border-t-2 border-gray-200" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "font-bold text-2xl mb-5" }, "Made with:", -1)
const _hoisted_8 = { class: "w-full xl:w-auto mt-20 mb-10 xl:my-0 flex items-start flex-wrap xl:items-end gap-2 xl:gap-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "LIVE VERSION", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "SOURCE CODE", -1)
const _hoisted_11 = {
  key: 0,
  class: "grid lg:grid-cols-2 gap-3 w-full max-w-8xl mb-20"
}
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReturnButton = _resolveComponent("ReturnButton")!
  const _component_ProjectAttributes = _resolveComponent("ProjectAttributes")!
  const _component_ComputerIcon = _resolveComponent("ComputerIcon")!
  const _component_GithubLogo = _resolveComponent("GithubLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ReturnButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
        class: "mb-20"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.project.title), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.project.description), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _hoisted_7,
        _createVNode(_component_ProjectAttributes, {
          attributes: _ctx.project.attributes
        }, null, 8, ["attributes"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.project.website)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openWindow(_ctx.project.website))),
              class: "flex items-center gap-3 xl:gap-8 text-white bg-[#924FFF] hover:opacity-75 py-3 px-5 rounded-lg"
            }, [
              _createVNode(_component_ComputerIcon, { class: "w-6" }),
              _hoisted_9
            ]))
          : _createCommentVNode("", true),
        (_ctx.project.github)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openWindow(_ctx.project.github))),
              class: "flex items-center gap-8 text-white bg-[#292929] hover:opacity-75 py-3 px-5 rounded-lg"
            }, [
              _createVNode(_component_GithubLogo, { class: "w-6" }),
              _hoisted_10
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.project)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.illustrations, (illustration) => {
            return (_openBlock(), _createElementBlock("img", {
              key: illustration,
              src: _ctx.loadProjectIllustration(illustration),
              alt: "project.title",
              class: "relative w-full h-full rounded border-2 border-gray-100"
            }, null, 8, _hoisted_12))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}